<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t2">The Horse Who Hated Christmas</span></p>
<p class="p0">By Hilary Walker</p>
<p class="p2"><a id="a2"></a><a href="#/005#a12">Chapter 1: Paula’s Problem</a></p>
<p class="p2"><span href="#/006#a13" title="Link target outside of Sample">Chapter 2: Pondering the Mystery</span></p>
<p class="p2"><span href="#/007#a14" title="Link target outside of Sample">Chapter 3: The Sleuthing Begins</span></p>
<p class="p2"><span href="#/008#a15" title="Link target outside of Sample">Chapter 4: The Phone Call</span></p>
<p class="p2"><span href="#/009#a16" title="Link target outside of Sample">Chapter 5: The Horse Whisperer</span></p>
<p class="p2"><span href="#/010#a17" title="Link target outside of Sample">Chapter 6: The Permission</span></p>
<p class="p2"><span href="#/011#a18" title="Link target outside of Sample">Chapter 7: The Pay Off</span></p>
<p class="p2"><span href="#/012#a19" title="Link target outside of Sample">Chapter 8: Christmas Morning</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?14240a36